import {
  AR_ACCOUNT,
  ARRIVAL,
  BILLING,
  CASH_REGISTER,
  CASHIER,
  COMPANY_TA_CARDS,
  CONCIERGE,
  CREATE_RESERVATION,
  DASHBOARD,
  DEPARTURE,
  DO_CHECKOUT,
  DO_EARLY_CHECKOUT,
  EDIT_DEPARTURE,
  EDIT_MARKET_CODE,
  END_OF_DAY_CHECK,
  EXCHANGE,
  FINANCIAL,
  FINANCIAL_ACCOUNT,
  FLASH_MANAGER,
  FORECAST,
  FRONT_DESK,
  GROUP_RESERVATION,
  GROUPS,
  GUEST,
  HOTEL,
  HOUSE_KEEPING,
  HOUSE_KEEPING_ROOM_STATUS,
  HOUSE_KEEPING_WORK_MANAGEMENT,
  IN_HOUSE,
  MAINTENANCE,
  PROMOS,
  RATE_EXCHANGE,
  RATE_MANAGER,
  RATES,
  REPORT,
  RESERVATION,
  REVENU_MANAGEMENT,
  ROOM_PLAN,
  SEARCH_RESERVATION,
  SETTINGS,
  SHOW_DETAILS,
} from './app_permissions';

/***************************** MENU_DASHBOARD *****************************/
export const MAIN_MENU_DASHBOARD_KEY_PERMISSION = `${HOTEL}.${DASHBOARD}`;

/***************************** MENU_RESERVATION *****************************/
export const MAIN_MENU_RESERVATION_KEY_PERMISSION = `${HOTEL}.${RESERVATION}`;
/**/ export const MAIN_MENU_SEARCH_RESERVATION_KEY_PERMISSION = `${MAIN_MENU_RESERVATION_KEY_PERMISSION}.${SEARCH_RESERVATION}`;
/**/ export const MAIN_MENU_FORECAST_KEY_PERMISSION = `${MAIN_MENU_RESERVATION_KEY_PERMISSION}.${FORECAST}`;
/**/ export const MAIN_MENU_GUEST_KEY_PERMISSION = `${MAIN_MENU_RESERVATION_KEY_PERMISSION}.${GUEST}`;
/**/ export const MAIN_MENU_CREATE_RESERVATION_KEY_PERMISSION = `${MAIN_MENU_RESERVATION_KEY_PERMISSION}.${CREATE_RESERVATION}`;

/***************************** MENU_FINANCIAL_ACCOUNT *****************************/
/**/ export const MAIN_MENU_FINANCIAL_ACCOUNT_KEY_PERMISSION = `${MAIN_MENU_RESERVATION_KEY_PERMISSION}.${FINANCIAL_ACCOUNT}`;

/**/ export const MAIN_MENU_FINANCIAL_ACCOUNT_SHOW_DETAILS_KEY_PERMISSION = `${MAIN_MENU_FINANCIAL_ACCOUNT_KEY_PERMISSION}.${SHOW_DETAILS}`;

/**/ export const MAIN_MENU_FINANCIAL_ACCOUNT_EDIT_DEPARTURE_KEY_PERMISSION = `${MAIN_MENU_FINANCIAL_ACCOUNT_SHOW_DETAILS_KEY_PERMISSION}.${EDIT_DEPARTURE}`;

/**/ export const MAIN_MENU_FINANCIAL_ACCOUNT_DO_CHECKOUT_KEY_PERMISSION = `${MAIN_MENU_FINANCIAL_ACCOUNT_SHOW_DETAILS_KEY_PERMISSION}.${DO_CHECKOUT}`;
/**/ export const MAIN_MENU_FINANCIAL_ACCOUNT_EDIT_MARKET_CODE_KEY_PERMISSION = `${MAIN_MENU_FINANCIAL_ACCOUNT_SHOW_DETAILS_KEY_PERMISSION}.${EDIT_MARKET_CODE}`;
/**/ export const MAIN_MENU_FINANCIAL_ACCOUNT_DO_EARLY_CHECKOUT_KEY_PERMISSION = `${MAIN_MENU_FINANCIAL_ACCOUNT_SHOW_DETAILS_KEY_PERMISSION}.${DO_EARLY_CHECKOUT}`;

/**/ export const MAIN_MENU_GROUP_RESERVATION_KEY_PERMISSION = `${MAIN_MENU_RESERVATION_KEY_PERMISSION}.${GROUP_RESERVATION}`;

/***************************** MENU_GROUPS *****************************/
export const MAIN_MENU_GROUPS_KEY_PERMISSION = `${HOTEL}.${GROUPS}`;

/***************************** MENU_FRONT_DESK *****************************/
export const MAIN_MENU_FRONT_DESK_KEY_PERMISSION = `${HOTEL}.${FRONT_DESK}`;
/**/ export const MAIN_MENU_ARRIVAL_KEY_PERMISSION = `${MAIN_MENU_FRONT_DESK_KEY_PERMISSION}.${ARRIVAL}`;
/**/ export const MAIN_MENU_DEPARTURE_KEY_PERMISSION = `${MAIN_MENU_FRONT_DESK_KEY_PERMISSION}.${DEPARTURE}`;
/**/ export const MAIN_MENU_IN_HOUSE_KEY_PERMISSION = `${MAIN_MENU_FRONT_DESK_KEY_PERMISSION}.${IN_HOUSE}`;
/**/ export const MAIN_MENU_ROOM_PLAN_KEY_PERMISSION = `${MAIN_MENU_FRONT_DESK_KEY_PERMISSION}.${ROOM_PLAN}`;

/***************************** MENU_CONCIERGE *****************************/
export const MAIN_MENU_CONCIERGE_KEY_PERMISSION = `${HOTEL}.${CONCIERGE}`;

/***************************** MENU_CASHIER *****************************/
export const MAIN_MENU_CASHIER_KEY_PERMISSION = `${HOTEL}.${CASHIER}`;
/**/ export const MAIN_MENU_CASH_REGISTER_KEY_PERMISSION = `${MAIN_MENU_CASHIER_KEY_PERMISSION}.${CASH_REGISTER}`;
/**/ export const MAIN_MENU_EXCHANGE_KEY_PERMISSION = `${MAIN_MENU_CASHIER_KEY_PERMISSION}.${EXCHANGE}`;
/**/ export const MAIN_MENU_RATE_EXCHANGE_KEY_PERMISSION = `${MAIN_MENU_CASHIER_KEY_PERMISSION}.${RATE_EXCHANGE}`;
/**/ export const MAIN_MENU_BILLING_KEY_PERMISSION = `${MAIN_MENU_CASHIER_KEY_PERMISSION}.${BILLING}`;

/***************************** MENU_REVENU_MANAGEMENT *****************************/
export const MAIN_MENU_REVENU_MANAGEMENT_KEY_PERMISSION = `${HOTEL}.${REVENU_MANAGEMENT}`;
/**/ export const MAIN_MENU_COMPANY_TA_CARDS_KEY_PERMISSION = `${MAIN_MENU_REVENU_MANAGEMENT_KEY_PERMISSION}.${COMPANY_TA_CARDS}`;
/**/ export const MAIN_MENU_RATES_KEY_PERMISSION = `${MAIN_MENU_REVENU_MANAGEMENT_KEY_PERMISSION}.${RATES}`;
/**/ export const MAIN_MENU_RATE_MANAGER_KEY_PERMISSION = `${MAIN_MENU_REVENU_MANAGEMENT_KEY_PERMISSION}.${RATE_MANAGER}`;
/**/ export const MAIN_MENU_PROMOS_KEY_PERMISSION = `${MAIN_MENU_REVENU_MANAGEMENT_KEY_PERMISSION}.${PROMOS}`;
/**/ export const MAIN_MENU_END_OF_DAY_CHECK_KEY_PERMISSION = `${MAIN_MENU_REVENU_MANAGEMENT_KEY_PERMISSION}.${END_OF_DAY_CHECK}`;
/**/ export const MAIN_MENU_FLASH_MANAGER_KEY_PERMISSION = `${MAIN_MENU_REVENU_MANAGEMENT_KEY_PERMISSION}.${FLASH_MANAGER}`;

/***************************** MENU_HOUSE_KEEPING *****************************/
export const MAIN_MENU_HOUSE_KEEPING_KEY_PERMISSION = `${HOTEL}.${HOUSE_KEEPING}`;
/**/ export const MAIN_MENU_HOUSE_KEEPING_ROOM_STATUS_KEY_PERMISSION = `${MAIN_MENU_HOUSE_KEEPING_KEY_PERMISSION}.${HOUSE_KEEPING_ROOM_STATUS}`;
/**/ export const MAIN_MENU_HOUSE_KEEPING_WORK_MANAGEMENT_KEY_PERMISSION = `${MAIN_MENU_HOUSE_KEEPING_KEY_PERMISSION}.${HOUSE_KEEPING_WORK_MANAGEMENT}`;

/***************************** MENU_MAINTENANCE *****************************/
export const MAIN_MENU_MAINTENANCE_KEY_PERMISSION = `${HOTEL}.${MAINTENANCE}`;

/***************************** MENU_FINANCIAL *****************************/
export const MAIN_MENU_FINANCIAL_KEY_PERMISSION = `${HOTEL}.${FINANCIAL}`;
/**/ export const MAIN_MENU_AR_ACCOUNT_KEY_PERMISSION = `${MAIN_MENU_FINANCIAL_KEY_PERMISSION}.${AR_ACCOUNT}`;

/***************************** MENU_REPORT *****************************/
export const MAIN_MENU_REPORT_KEY_PERMISSION = `${HOTEL}.${REPORT}`;

/***************************** MENU_REPORT *****************************/
export const MAIN_MENU_SETTINGS_KEY_PERMISSION = `${HOTEL}.${SETTINGS}`;
